export const GRADIENT = {
  angle: 0,
  startColor: "#ff0000",
  stopColor: "#ffff00"
};

export const SHADOW = {
  inset: false,
  vertical: 10,
  horizontal: 0,
  blur: 10,
  opacity: 0.5,
  color: "#000000"
};

export const BG_SHADOW = {
  inset: true,
  vertical: 3,
  horizontal: 0,
  blur: 3,
  opacity: 0.4,
  color: "#000000"
};
